<template>
  <div class="app-container">
    <el-card class="box-card">
      <div v-if="scope.technicianInfoId" class="scope-tip">
        当前身份：<b>{{ scope.realName }}</b>（{{ scope.levelName }}）
        <!-- 后端 resolveScope() 的 ids 是先 add(本人) 再加名下老师，督导看到的是「本人及名下老师」，
             原文案写「只展示名下老师的数据」与实际不符（督导归属未配时屏幕上全是本人数据） -->
        <span v-if="scope.restricted && scope.levelName === '督导'">，展示本人及名下老师的数据</span>
      </div>
      <!-- 没有技术线身份、又没有「查看全部教培数据」权限：三张表都会是空的，
           不给提示的话看着像功能坏了 -->
      <div v-else-if="scope.restricted" class="scope-tip">
        当前账号未匹配到在职的技术线身份，暂无可查看的数据。如需查看全部，请联系管理员分配「查看全部教培数据」权限。
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="技术老师签到与出货" name="teacher">
          <teacher-tab v-if="activeTab === 'teacher'" :scope="scope" />
        </el-tab-pane>
        <el-tab-pane label="客户数据明细" name="customer">
          <customer-tab v-if="activeTab === 'customer'" :scope="scope" />
        </el-tab-pane>
        <el-tab-pane label="新加盟客户年度进货" name="newCustomer">
          <new-customer-tab v-if="activeTab === 'newCustomer'" :scope="scope" />
        </el-tab-pane>
        <!-- 大客户看板（REQ-2026-107511）：全量数据、不按登录身份限定，与上面三张不同 -->
        <el-tab-pane label="3.0 交付周报" name="bigWeekly">
          <big-weekly-tab v-if="activeTab === 'bigWeekly'" />
        </el-tab-pane>
        <el-tab-pane label="3.0 客户明细" name="bigDetail">
          <big-detail-tab v-if="activeTab === 'bigDetail'" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import eduStatsApi from '@/api/count/eduStats'
import teacherTab from './teacher.vue'
import customerTab from './customer.vue'
import newCustomerTab from './newCustomer.vue'
import bigWeeklyTab from './bigWeekly.vue'
import bigDetailTab from './bigDetail.vue'

/**
 * 教培数据统计（REQ-2026-125349）
 * 三张报表对应教培部三份周/月/年模板；数据范围后端按登录身份限定，这里只负责提示
 */
export default {
  name: 'EduStats',
  components: { teacherTab, customerTab, newCustomerTab, bigWeeklyTab, bigDetailTab },
  data() {
    return {
      activeTab: this.$route.query.tab || 'teacher',
      scope: { restricted: false }
    }
  },
  created() {
    eduStatsApi.getScope().then(({ data }) => {
      this.scope = data || { restricted: false }
    })
  }
}
</script>

<style scoped>
.scope-tip {
  margin-bottom: 8px;
  padding: 6px 12px;
  background: #f4f4f5;
  color: #606266;
  font-size: 13px;
  border-radius: 4px;
}
</style>
